import styled, {keyframes} from "styled-components";

export const CrewStyle = styled.div`
    height: 100%;
    width: 100%;
    background-color: #E5F8FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`
export const FormRow = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 100px;
`;

export const FormRow2 = styled.div`
  display: flex;
  /* justify-content: space-between; */
`;

interface ChoosePlanCardProps {
    isExpanded?: boolean;
  }

export const ConfirmButton = styled.button<ChoosePlanCardProps>`
  background-color: #FF5641;
  display: ${({ isExpanded }) => (isExpanded ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  width: 200px;
  padding: 10px;
  border: none;
  border-radius: 50px / 40px;
  color: #FFFFFF;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;

  position: absolute;   
  bottom: -20px;        
  left: 78%;            
  z-index: 1;
`;


export const ChoosePlanCard = styled.div`
    position: relative;
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    border-radius: 20px;
    background-color: #ffffffcc;
    align-items: center;
    justify-content: center;
    padding: 50px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);
    transition: height 0.3s ease;
    margin-bottom: 200px;

    h1 {
        color: black;
        font-weight: 700;
        font-size: 15px;
        padding-left: 12px;
        margin-bottom: 10px;
        align-self: flex-end;
    }

    h2 {
    color: black;
    font-size: 20px;
    margin-top: 10px;
    }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 95%;
  gap: 15px;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 90px;

  select{
    height: 35px;
    border: 1px solid #ccc;
    border-radius: 60px;
    padding: 0 10px;
    font-size: 14px;
    outline: none;
    width: 103%;

    &:focus {
      border-color: #E0F1FF;
      border-width: 2px;
      box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
  }

  button{
    background-color: white;
    height: 35px;
    border: 1px solid #ccc;
    border-radius: 60px;
    padding: 0 10px;
    font-size: 14px;
    outline: none;
    width: 101.5%;
    cursor: pointer;

    &:focus {
      border-color: #E0F1FF;
      border-width: 2px;
      box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
  }
`;

export const FormInput = styled.input`
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 60px;
  padding: 0 10px;
  font-size: 14px;
  outline: none;
  width: 100%;

  &:focus {
    border-color: #E0F1FF;
    border-width: 2px;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`;

export const WrapContent = styled.div`
    width: 75%;
    height: 80%;
    display: flex;
    flex-direction: column;
    /* background-color: red; */

    h1{
        margin: 15px 9px;
        padding: 0;
        color: #FF5742;
    }

    h2{
        color: black;
        font-size: 15px;
        margin-top: auto;
    }

    h3{
        color: #005CA9;
        font-size: 30px;
        margin-left: 9px;
        margin-top: 10px;
    }
`

export const PlansDropdown = styled.select`
    height: 30px;
    width: 100%;
    background-color: #D0E1EF;
    justify-content: space-between;
    border: none;
    border-width: 2px;
    border-color: transparent;
    border-style: none;
    color: black;
    outline: none;
    border-radius: 60px;
    margin-bottom: 40px;

    &:focus {
    border-color: #5c8e; 
    border-width: 2px;
    outline: none;
    border-width: 0;
    border: none;
  }
`

export const DependentsButton = styled.button`
  width: 180px;
  padding: 15px;
  margin-right: -20px;
  background-color: #D0E1EF;
  color: #005CA9;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-end;
  border: none;
  border-radius: 60px;
  cursor: pointer;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.5);
`
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20000;
  border-radius: 8px;
`;

export const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 6px solid #005ca9;
  border-top: 6px solid transparent;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;